// i18n.js (Localization Configuration File)
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './assets/lang/en.json';
import fr from './assets/lang/fr.json';

Vue.use(VueI18n);



const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'fr', // Default language
    messages: { en: en, fr: fr } // Messages load karna
});

export default i18n;
